export default __webpack_public_path__ + "static/media/iconBlendLightPod.5b1df940.svg";